import { Loadable } from '../../components/common/loadable/loadable';

export const ProjectsContainer = Loadable<any>({
  loader: () =>
    import(/* webpackChunkName: "projects" */ './projects').then(
      (module) => module.ProjectsContainer,
    ),
});
